import { DEFAULT_RENDER_SETTINGS } from '../constants'

export const initialRenderSettingsState = {
  renderSettings: { ...DEFAULT_RENDER_SETTINGS },
}
